module.exports = __webpack_public_path__ + "img/HC1023-164.fb9ed708.jpg";